import en from './en.json'
import ru from './ru.json'
import it from './it.json'
import he from './he.json'
import ar from './ar.json'

import enUS from 'ant-design-vue/es/locale/en_US';
import ruRU from 'ant-design-vue/es/locale/ru_RU';
import itIT from 'ant-design-vue/es/locale/it_IT';
import heIL from 'ant-design-vue/es/locale/he_IL';
import arEG from 'ant-design-vue/es/locale/ar_EG';

import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import 'dayjs/locale/it';
import 'dayjs/locale/he';
import 'dayjs/locale/ar';


const translations = {
	en: en,
	ru: ru,
	it: it,
	he: he,
	ar: ar,
}

const antdLocales = {
	en: enUS,
	ru: ruRU,
	it: itIT,
	he: heIL,
	ar: arEG,
}

const fallbackLocale = 'en';

export { translations, antdLocales, fallbackLocale };
